<template>
  <v-card class="pa-2 mb-2 " flat style="border-radius: 10px;" >
    <v-layout row>
      <v-avatar size="85" class="pl-1 pt-3">
        <v-img
          :src="user.avatar"
        />
      </v-avatar>
      <span style="font-size: 17px;">
        <span class="ml-3 font-weight-bold" >{{ user.name }}</span>
        <br />
        <span class="ml-3 grey--text text--darken-1">Bid: &#8377;{{ user.bid }}</span>
        <br />
        <span class="ml-3 font-italic grey--text text--darken-1">{{ user.email }}</span>
        <br />
        <span class="ml-3 grey--text text--darken-1">+91-{{ user.contact }}</span>
        
      </span>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    user: Object
  }
};
</script>
